import { Component, Prop, h, Event, EventEmitter } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
    tag: 'form-button',
    styleUrl: 'form-button.css',
    shadow: false,
})
export class FormButton {
    @Prop() inputValue: InputFomat;
    @Event() buttonClick: EventEmitter<any>;

    private triggerClickEvent = (_) => {
        this.buttonClick.emit();
    }

    render() {
        return (
                <ix-button 
                    class="place-button" 
                    type="{this.inputValue.type}" 
                    outline={this.inputValue.type !== 'submit'}
                    onClick={(event) => this.triggerClickEvent(event)} 
                    >
                        {this.inputValue.label}
                    </ix-button>
        );
    }
}
